if (!window.Eurus.loadedScript.has('collection-list-product-badges-block.js')) {
  window.Eurus.loadedScript.add('collection-list-product-badges-block.js');

  document.addEventListener('alpine:init', () => {
    Alpine.data('xCollectionListProductBadgesBlock', (containerId) => ({
      loadCollectionListProductBadges() {
        if (!this.$store.xBadges) return;

        const container = document.getElementById(containerId);
        if (!container) return;

        this.$store.xBadges.load(this.$el, (el) => {
          const hasBadges = [...el.childNodes].some((node) => node.nodeType === 1 && node.tagName === 'DIV');

          el.classList.remove('min-h-[45px]');
          container.classList.remove('min-h-[45px]');
          container.classList.toggle('mb-4', hasBadges);
          container.classList.toggle('md:mb-5', hasBadges);
          el.removeAttribute('x-intersect.once.margin.1200px');
          container.innerHTML = el.outerHTML;
          document.dispatchEvent(new CustomEvent('eurus:badges:loaded'));
        }, container);
      }
    }));
  });
}
